export default "__VITE_ASSET__iRiIOzCc__"